import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipPositionDirective } from './tooltip-position.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [TooltipPositionDirective],
  exports: [TooltipPositionDirective]
})
export class TooltipPositionModule {}
